import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { getPageTotalCount } from 'utils/utils';
import { DataTable, TablePagination, Breadcrumb } from '../../../components/common';
import RouteNames from '../../App/RouteNames';
import { searchRoleGroups, setParamsRoleGroups } from '../actions';
import { makeGetlistRoleGroups, makePageRoleGroupsParams, errorMessageRoleGroups } from '../selectors';
import { RoleGroupSearchForm } from '../../../components/OperationHub';
import { makeGetPermissionsUserManagement } from '../../App/selectors';
import {
  checkPermissionGetRoleGroups,
  checkPermissionCreateRoleGroups,
  checkPermissionSearchRoleGroups,
} from '../CheckPermission';

const RoleSort = {
  name: {
    asc: 'name_ASC',
    desc: 'name_DESC',
  },
  type: {
    asc: 'type_ASC',
    desc: 'type_DESC',
  },
  status: {
    asc: 'status_ASC',
    desc: 'status_DESC',
  },
};

const tableColumns = [
  {
    name: 'status',
    label: 'common:label.status',
    sortable: true,
    isRenderT: true,
    render: (colName, item, t) => {
      const slt = t ? t('selections:permissionStatus')().find(val => val.value === item.status) : '';
      return <span>{slt ? slt.label : ''}</span>;
    },
  },
  {
    name: 'type',
    label: 'common:label.type',
    sortable: true,
  },
  {
    name: 'name',
    label: 'common:label.name',
    sortable: true,
    style: { minWidth: '100px' },
  },
  {
    name: 'description',
    label: 'common:label.description',
  },
];

class UserManagementRoleGroup extends Component {
  state = {
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
  };

  static getDerivedStateFromProps(props, state) {
    if (state && props.listRoleGroups) {
      return {
        totalCount: getPageTotalCount({ ...state, items: props.listRoleGroups }),
      };
    }
    return {};
  }

  componentDidMount() {
    const { location } = this.props;
    if (location && location.state && location.state.filter) {
      this.setState({ filter: location.state.filter }, () => {
        this.doSearchItems();
      });
    } else {
      this.doSearchItems();
    }
  }

  onClickRow = e => {
    e.preventDefault();
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doSearchItems());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doSearchItems());
  };

  onSubmitSearch = filteredData => {
    this.setState({ filter: filteredData, page: 0 }, () => this.doSearchItems());
  };

  doSearchItems = () => {
    const { page, size, sorted, filter } = this.state;
    const { searchRoleGroups } = this.props;
    const sort =
      sorted && sorted.sortCol && sorted.sortDir && RoleSort[sorted.sortCol]
        ? RoleSort[sorted.sortCol][sorted.sortDir]
        : null;
    this.setState({ isSearching: true });
    const params = {
      page: page + 1,
      size,
      filter,
    };
    if (sort) {
      params.sort = sort;
    }
    searchRoleGroups(params, () => {
      this.setState({ isSearching: false, filter, sort });
    });
  };

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => this.doSearchItems());
  };

  render() {
    const { listRoleGroups, permissionsUser, t, location } = this.props;
    const { sorted, isSearching, page, size, totalCount, filter } = this.state;
    let newColumnTable = cloneDeep(tableColumns);

    let modeCreateRoleGroups = 0;
    let modeGetRoleGroups = 0;
    let modeSearchRoleGroups = 0;

    if (permissionsUser && permissionsUser.userModulePermissions) {
      const listPermission = permissionsUser.userModulePermissions;
      modeCreateRoleGroups = checkPermissionCreateRoleGroups({ listPermission });
      modeGetRoleGroups = checkPermissionGetRoleGroups({ listPermission });
      modeSearchRoleGroups = checkPermissionSearchRoleGroups({ listPermission });
    }

    newColumnTable = [
      {
        name: 'id',
        label: 'common:label.id',
        render: (colName, item) => (
          <Link
            className="text-success"
            to={{
              pathname: RouteNames.prettifyPath(RouteNames.userManagementRoleGroupEdit.path, item.id),
              state: { filter },
            }}
          >
            {item.id}
          </Link>
        ),
      },
      ...newColumnTable,
      {
        name: 'action',
        label: 'common:label.action',
        isRenderT: true,
        render: (colName, item, t) => (
          <Link
            className="btn btn-outline-success btn-sm"
            to={{
              pathname: RouteNames.prettifyPath(RouteNames.userManagementRoleGroupEdit.path, item.id),
              state: { filter },
            }}
          >
            {t ? t('common:label.view') : ''}
          </Link>
        ),
      },
    ];

    if (modeSearchRoleGroups === 0) return '';

    if (modeGetRoleGroups === 0) {
      newColumnTable[0] = {
        name: 'id',
        label: 'common:label.id',
      };
      newColumnTable.splice(newColumnTable.length - 1, 1);
    }

    const tableConfig = {
      columns: newColumnTable,
      sorted: { ...sorted },
      data: listRoleGroups,
      onSort: this.onSortColumn,
      onClickRow: this.onClickRow,
    };
    return (
      <div>
        <div className="page-title">
          <div className="row">
            <div className="col-sm-6">
              <Link
                to={
                  modeCreateRoleGroups !== 2
                    ? RouteNames.userManagementRole.path
                    : { pathname: RouteNames.userManagementRoleGroupAdd.path, state: { filter } }
                }
                className="button x-small"
              >
                {modeCreateRoleGroups !== 2 ? t('label.back') : t('label.createNewRoleGroup')}
              </Link>
            </div>

            <div className="col-sm-6">
              <Breadcrumb
                items={[
                  { name: t('navbar:operationsHub.subMain.userManagement'), url: RouteNames.userManagementRole.path },
                  { name: t('userManagementPage:sidebar.roleGroups'), url: RouteNames.userManagementRoleGroup.path },
                ]}
              />
            </div>
          </div>
        </div>

        <br />
        <div className="col-md-12 mb-30">
          <div className="card card-statistics h-100">
            <div className="card-body">
              <div className="repeater-file">
                <div data-repeater-list="group-a">
                  <RoleGroupSearchForm
                    onSubmit={this.onSubmitSearch}
                    isSubmitting={isSearching}
                    defaultFilter={location && location.state && location.state.filter ? location.state.filter : {}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-sm-12 mb-30">
          <div className="card card-statistics h-100">
            <div className="card-body">
              <DataTable {...tableConfig} isLoading={isSearching} />
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
      </div>
    );
  }
}

UserManagementRoleGroup.propTypes = {
  searchRoleGroups: PropTypes.func.isRequired,
  listRoleGroups: PropTypes.arrayOf(PropTypes.any),
  permissionsUser: PropTypes.objectOf(PropTypes.any),
};

UserManagementRoleGroup.defaultProps = {
  listRoleGroups: [],
  permissionsUser: {},
};

const mapStateToProps = createStructuredSelector({
  listRoleGroups: makeGetlistRoleGroups() || [],
  params: makePageRoleGroupsParams() || {},
  errorMessage: errorMessageRoleGroups() || '',
  permissionsUser: makeGetPermissionsUserManagement() || {},
});

export default withTranslation('common')(
  connect(mapStateToProps, { searchRoleGroups, setParamsRoleGroups })(UserManagementRoleGroup)
);
